import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ClientUsersUsageSettingsFormErrorStatesEnum {
    UpdateClientUsersUsageSettings = ErrorStateScheduleEnum.ClientUsersUsageSettingsFormErrorStatesStartIndex,
}
